import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from '../../services/user/user.service';
import { ConfigService } from '../../services/config/config.service';
import { ActivatedRoute } from '@angular/router';
import { NoteService } from '../../services/note/note.service';
import { ValidationService } from '../../services/validation/validation.service';
import { DisplayService } from '../../services/display/display.service';
import { DataService } from '../../services/data/data.service';
import { CommsService } from '../../services/comms/comms.service';

@Component({
	selector: 'pcm-user-login',
	templateUrl: './user-login.component.html',
	styleUrls: ['./user-login.component.scss']
})

export class UserLoginComponent implements OnInit {

	public username: any = '';
	public password: any = '';

	ssoURLs: any = {};
	ibmidURLs: any = {};
	announcement: String;

	constructor(
		public userService: UserService,
		public configService: ConfigService,
		public noteService: NoteService,
		private route: ActivatedRoute,
		public validationService: ValidationService,
		public displayService: DisplayService,
		public dataService: DataService,
		private commsService: CommsService
	) { }

	ngOnInit() {
		// need check Microsoft Edge browser
		if (navigator.appName === 'Microsoft Internet Explorer'
			// pre-chromium Edge use "Edge", chromium Edge uses "Edg"
			|| (navigator.appName === 'Netscape' && navigator.appVersion.indexOf('Edge') > -1)
			|| (navigator.appName === 'Netscape' && navigator.appVersion.indexOf('Trid') > -1)) {
				this.noteService.displayWarning(
					'You are accessing the Contingent Labor on IBM Blockchain application using an unsupported browser.'
					+ ' Please consider logging on with Chrome, Firefox, or the latest version of Edge.', false);
		}

		const redirecURI = encodeURIComponent(window.location.origin);
		this.ssoURLs = this.userService.getSSOLoginURL(redirecURI);
		this.ibmidURLs = this.userService.getIBMIdLoginURL(redirecURI);
		this.route.queryParams.subscribe(params => {
			if (params.code) {
				this.userService.sendSSOLogin(params.code, redirecURI);
			}
		});

		this.commsService.getAnnouncement().subscribe(response => {
			const announcementObject = this.commsService.getSuccessData(response);
			if (announcementObject) {
				this.announcement = announcementObject.message;
			}
		});
	}

	submitLogin(form: NgForm) {
		if (this.username.trim().toLowerCase().endsWith('ibm.com')) {
			localStorage.setItem(this.configService.ssoCompanyProp, 'ibm');
			window.location.href = this.ssoURLs.IBM;
		} else {
			//this.userService.sendLogin(this.username, this.password);
			localStorage.setItem(this.configService.ssoCompanyProp, 'nonibm');
			window.location.href = this.ibmidURLs.NonIBM;
		}
	}

	selectProfile(form: NgForm) {
		console.log('SELECTED PROFILE', this.userService.selectedPersona);
		this.userService.choosePersona(this.userService.selectedPersona);
	}

	onCloseNote() {
		this.noteService.currentNote.active = false;
	}
}
